import { ElLoading } from 'element-plus'
import { ref } from 'vue'

export function useLoading({
  text = 'Loading',
  background = 'rgba(0, 0, 0, 0.7)',
  customClass = 'g-custom-loading'
} = {}) {
  const loading = ref()
  const show = () => {
    loading.value = ElLoading.service({
      lock: true,
      text: text,
      background: background,
      customClass: customClass
    })
  }
  const close = () => {
    loading.value.close()
  }

  return { show, close }
}
